import agent from 'superagent';
import defaults from 'superagent-defaults';
import promise from 'superagent-promise';

// lib
import jwtFromLocalStorage from '../../lib/jwtFromLocalStorage';

const client = defaults(promise(agent, Promise));
client
  .set('Accept', process.env.API_VERSION.replace(/\\/, ''))
  .on('request', (req) => {
    req.url = process.env.API_URL + req.url;

    req.header['Content-Type'] = 'application/json';
    req.header['X-Key-Inflection'] = 'camel';
    req.header.Authorization = `Bearer ${jwtFromLocalStorage()}`;
  });

export default client;



// WEBPACK FOOTER //
// ./app/sources/api/client.js